export default function Hero() {
  return (
    <section className="relative h-screen flex flex-col lg:flex-row">
      <div className="w-full lg:w-1/2 bg-background-100 flex items-center px-6 md:px-16 pt-24 lg:pt-0">
        <div className="max-w-lg">
          <span className="inline-block text-xs font-label uppercase tracking-[2px] text-foreground-500 mb-5 animate-fade-in-up">
            Product Research Platform
          </span>
          <h1 className="font-heading text-5xl md:text-6xl lg:text-7xl text-foreground-950 leading-[1.08] mb-6 animate-fade-in-up-delay-1">
            Curated Superbuy
            <br />
            Spreadsheet System
          </h1>
          <p className="text-base md:text-lg text-foreground-600 leading-relaxed mb-8 max-w-md animate-fade-in-up-delay-2">
            Stop wasting hours on manual product hunting. Superbuy Sheet gives you the organized research framework that serious fashion shoppers trust to find, compare, and track the best products across 14 categories.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 animate-fade-in-up-delay-3">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full bg-primary-500 text-background-50 text-sm font-label font-medium whitespace-nowrap cursor-pointer transition-all hover:bg-primary-600"
            >
              superbuy sheet
              <span className="w-5 h-5 rounded-full border border-background-50/60 flex items-center justify-center">
                <i className="ri-arrow-right-up-line text-xs"></i>
              </span>
            </a>
            <a
              href="#categories"
              className="inline-flex items-center justify-center px-7 py-3.5 rounded-full border border-foreground-300 text-foreground-800 text-sm font-label font-medium whitespace-nowrap cursor-pointer transition-all hover:border-foreground-950 hover:text-foreground-950"
            >
              Explore Categories
            </a>
          </div>
        </div>
      </div>

      <div className="w-full lg:w-1/2 h-[50vh] lg:h-full relative overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20carefully%20curated%20contemporary%20streetwear%20styled%20on%20a%20minimal%20clothing%20rack%20against%20a%20warm%20toned%20plaster%20wall%20soft%20diffused%20afternoon%20light%20from%20a%20large%20window%20creating%20gentle%20gradients%20a%20pair%20of%20designer%20sneakers%20placed%20below%20on%20a%20natural%20fiber%20rug%20sophisticated%20boutique%20atmosphere&width=1400&height=1800&seq=hero-fashion-2026-v4&orientation=portrait"
          alt="Superbuy Sheet fashion product research lifestyle"
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-100 via-transparent to-transparent lg:bg-gradient-to-r lg:from-transparent lg:via-transparent lg:to-transparent"></div>
      </div>
    </section>
  );
}